'use client'
import React, { useState, useEffect, useMemo, useRef } from 'react'
import { useRouter, usePathname } from 'next/navigation'
import withApiUrl from '../utils/apiUrlHoc'
import {
  deleteProductFromWishlist,
  addProductIntoWishlist,
  getWishlistProducts,
  getWishlistProductById,
} from '../repositories/wishlistRepository'
import { useDispatch, useSelector } from 'react-redux'
import { toggleLoginForm } from '../reduxToolkit/authSlice'

export const WishlistContext = React.createContext({
  wishlist: [],
  loading: false,
  wishlisted: () => {},
  getWishlist: () => {},
  addToWishlist: () => {},
  getWishlistCount: () => {},
  removeFromWishlist: () => {},
})

function WishlistProvider(props) {
  const dispatch = useDispatch()
  const router = useRouter()
  const pathname = usePathname()
  const [state, updateState] = useState({
    wishlist: [],
    loading: false,
  })

  const setState = newState => {
    updateState({
      ...state,
      ...newState,
    })
  }
  const { isLoggedin, userData } = useSelector(state => state.auth)
  const { address } = useSelector(state => state.address)
  const prevProps = useRef({ isLoggedin })

  const wishlisted = productId => {
    const { wishlist } = state
    for (let i = 0; i < wishlist?.length; i += 1) {
      if (+wishlist[i].id === +productId) {
        return true
      }
    }
    return false
  }

  const getWishlist = async () => {
    setState({ loading: true })
    const { accessToken } = userData
    // // redirec to login page
    if (!accessToken && pathname !== '/login' && pathname !== '/') {
      router.replace('/login')
    }
    const { storeId } = address || {}

    const data = { params: { storeId } }

    try {
      const response = await getWishlistProducts(data)

      const { wishList } = response

      // if no there is no default wishlist
      // backend only create default wishlist after adding product to wishlist
      // for fresh signed up user there is no default wishlist(until he/she add a new product to wishlist)
      if (wishList.length === 0 || wishList?.[0]?.productCount === 0) {
        setState({
          wishlist: [],
          loading: false,
        })
      }

      const { id } = wishList?.[0]?.productCount > 0 ? wishList[0] : {} // grabbing wishlist id
      const wishListData = {
        id,
      }
      if (id) {
        const res = await getWishlistProductById(wishListData)

        const product = (res && res.wishList.product) || []
        setState({
          wishlist: product,
          loading: false,
        })
      }
    } catch (error) {
      setState({
        error,
        loading: false,
      })
    }
  }

  const add = async id => {
    const data = { productId: [id] }
    try {
      const res = await addProductIntoWishlist(data)

      const { product } = res.wishList || { product: [] }
      setState({ wishlist: product })
    } catch (error) {
      setState({
        error,
      })
    }
  }

  const remove = async id => {
    const data = { productId: [id] }

    try {
      await deleteProductFromWishlist(data)
      await getWishlist()
    } catch (error) {
      setState({
        error: error.data,
      })
    }
  }

  const addToWishlist = id => {
    const { accessToken } = userData
    if (accessToken) {
      add(id, accessToken)
    } else {
      // show login form
      dispatch(toggleLoginForm(true))
    }
  }

  const removeFromWishlist = productId => {
    const { accessToken } = userData
    if (accessToken) {
      remove(productId, accessToken)
    } else {
      // show login form
      dispatch(toggleLoginForm(true))
    }
  }

  const getWishlistCount = () => {
    const { wishlist } = state
    return wishlist?.length
  }

  useEffect(() => {
    if (isLoggedin) {
      getWishlist()
    }
    if (prevProps.current.isLoggedin && !isLoggedin) {
      setState({
        wishlist: [],
      })
    }

    prevProps.current.isLoggedin = isLoggedin
  }, [isLoggedin])

  const { children } = props
  const { wishlist, loading } = state

  const contextValue = useMemo(
    () => ({
      wishlist,
      loading,
      wishlisted,
      getWishlist,
      addToWishlist,
      getWishlistCount,
      removeFromWishlist,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [wishlist, loading]
  )

  return (
    <WishlistContext.Provider value={contextValue}>
      {children}
    </WishlistContext.Provider>
  )
}
export default withApiUrl(WishlistProvider)
